import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcArrowUpCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M12 17V7m0 0-4.09 4.09M12 7l4.092 4.09M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		vectorEffect: "non-scaling-stroke"
	})
});
export default SvgIcArrowUpCircle;
